<template>
  <div>
    <button
      class="btn btn-with-addon"
      style="background-color: #107c41; color: #fff;"
      :loading="loading"
      @click="handleExport"
    >
      <span class="btn-addon">
        <i class="btn-addon-icon fe fe-download" />
      </span>
      {{ loading ? 'Exporting...' : 'Export' }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'ExportStaff',

  data: function() {
    return {
      loading: false,
    }
  },
  methods: {
    handleExport() {
      this.loading = true
      this.$http
        .get('/api/staff/export', {
          responseType: 'arraybuffer',
        })
        .then(({ data }) => {
          let blob = new Blob([data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          })
          this.loading = false
          this.$notification['info']({
            message: 'Staffs export started!',
            description: `Staffs export  has started! You will be notified once it is completed!`,
          })

          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = 'Staffs.xlsx'
          link.click()
        })
        .catch((error) => {
          this.loading = false
          this.$neoNotify.error(error)
        })
    },
  },
}
</script>
